const config = {
    LOCAL_API_URL: 'https://mss.shachihata.com/api/api',
}
export default config
